export default {"src":"/_next/static/media/Arrow-right-blu.dd05ac56.svg","height":13,"width":15,"blurWidth":0,"blurHeight":0};